import { render, staticRenderFns } from "./Dialog-Gallery.vue?vue&type=template&id=488353bc&"
import script from "./Dialog-Gallery.vue?vue&type=script&lang=js&"
export * from "./Dialog-Gallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports